
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { signinCloseConsent , signOpenChangeDefaultPassword , updateConcent , popupOpenTierShow} from "../../actions";
import IntlMessages from "../../utils/IntlMessages";
import {
  reduxForm,
  Field ,
} from "redux-form";
import renderInputCheckbox from '../../utils/CustomField/renderInputCheckbox'
import Policy_en from "../policy_en";
import Policy_th from "../policy_th";

class PopupConsent extends Component {

  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.state = {
      scrollBottomAccept : false
    }
  }




onScroll = () => { 
  const scrollTop = this.refs.scrollTop
  const scrollHeight = this.refs.scrollHeight
  const clientHeight = this.refs.clientHeight
  if( scrollHeight - clientHeight  === scrollTop  ){
    this.setState({
      scrollBottomAccept: true
    })
  }
 
  this.setState({
    scrollTop: scrollTop
  })
}


  render() { 
    const {locale , authMember , handleSubmit  , submitting , pristine} = this.props;
   
    // if (authMember && authMember.success ) {
    //   this.props.signinCloseConsent();
    // }

    if(!this.props.displayConsent) {
         return (<div></div>)
    }

    // if(this.props.is_consent){
      
    //   //this.props.updateConcent({ version : process.env.REACT_APP_API || 1})
    //   this.props.signinCloseConsent();
    //   //this.props.signOpenChangeDefaultPassword()
    //   //this.props.updateDefaultPassword({ version : Version , contact : "1234"})
    // }


     return (
      <div
      className="modal fade show"
      role="dialog"
      tabIndex="-1"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content white">
          <form onSubmit = {  
            handleSubmit(() => {

              this.props.updateConcent({ version : Number(process.env.REACT_APP_TMBAM_CONSENT_V || 2)})

              // if(!this.props.is_default_password_changed){
              //   this.props.signinCloseConsent();
              //   this.props.signOpenChangeDefaultPassword();
              // }else{
              //   this.props.signinCloseConsent();
              //   this.props.popupOpenTierShow()
              // }
           
            })
          }>



            <div className="modal-header" >
            <IntlMessages id="footer.term"></IntlMessages>
            
            </div>
            <div className="modal-body text-left">
            <section id="divR"  onScroll={this.onScroll} ref={input => {this.refs = input;}} style={{ overflowY: "scroll" , maxHeight : "400px"}}>
              {
                locale === "en" ? <Policy_en />  :  <Policy_th />
              }

            </section>
 
            </div>
            <div className="modal-foot container text-center">
                    <div>
                <label htmlFor="consent_input"></label>
                <div>
                  <Field name="consent" id="consent_input"   component={renderInputCheckbox} type="checkbox" text={(<IntlMessages id="consent.text"></IntlMessages>)}  /> 
                </div>
              </div>
                    <button
                      type="submit"
                      disabled={ ( pristine ||submitting) }
                      className={"btn btn-wrs mb-3"}
                   //  onClick={(e) => this.props.signinCloseConsent()}
 
                    >
                      <IntlMessages id="consent.accept"></IntlMessages>
                    </button>
            
            

              {/* <button
                type="button"
                className={""}
                onClick={this.onClickClose}
              >
                <IntlMessages id="consent.decline"></IntlMessages>
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </div>
    );
  }
}

function validate(values) {
  const errors = {}; 
  if(!values){
    errors.defaullt = 'Required'}
  else  if(!values.consent){
    errors.consent = 'Required'}

    return errors
    
}

const mapStateToProps = ({ form ,setting, auth }) => {
  const { authMember , displayConsent , authData} = auth;
  const {
    locale: { locale },
  } = setting; 
  const formValues = form.FormConsent ? form.FormConsent.values : '';
 
  const is_default_password_changed = authMember && authMember.is_change_password_default === "true" ? true : false
  const is_consent = authMember  && authMember.consent_status  === "enable" ? true : false
  return { locale, authMember, displayConsent , formValues , is_default_password_changed , is_consent };
};

PopupConsent = reduxForm({ validate,  form: "FormConsent"})(PopupConsent);

export default connect(mapStateToProps, {
  push,
  signinCloseConsent, 
  updateConcent,
  signOpenChangeDefaultPassword,
  popupOpenTierShow
})(PopupConsent);
